export const REGION = {
  US: 'US',
  UK: 'UK',
} as const;

export type Region = keyof typeof REGION;
